import { render, staticRenderFns } from "./RecommandModule.vue?vue&type=template&id=0c2e85c6"
import script from "./RecommandModule.vue?vue&type=script&lang=js"
export * from "./RecommandModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports